import { SUBSCRIPTION_TYPE, STUDENT_OFFER } from "common/constants/v2/Constants";

export function determineProductDisplayName(type, productName, bulkSubscriptionName, offerType) {
    if (offerType === STUDENT_OFFER) {
        return `Student ${ determineProductDisplayName(type, productName, bulkSubscriptionName, null) }`;
    }

    if (type === SUBSCRIPTION_TYPE.BULK) {
        return `${ bulkSubscriptionName } - Digital Group Subscription`;
    }

    return productName
        ? productName
        : (type === SUBSCRIPTION_TYPE.ALL ? "All Access" : "Digital");
}

export function pricingStrategy(metadata) {
    const {
        nextBillingAmount,
        nextBillingDate,
        previousBillingCharge
    } = metadata || {};

    return {
        nextChargePrice: nextBillingAmount,
        nextChargeDate: nextBillingDate,
        previousChargePrice: previousBillingCharge
    };
}
